import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Query from '@/modules/shared/domain/use-cases/query';
import TYPES from '../../types';
import { StateManager } from '../../domain/state/state-manager';
import { FinancialInstitutionRepository } from '../../domain/repository/financial-institution-repository';
import { FinancialInstitutionEntity } from '../../domain/entities/financial-institution-entity';

@Injectable()
export default class SearchFinancialInstitutionsQuery
  extends Query<Promise<Array<FinancialInstitutionEntity>>> {
  @Inject(TYPES.CATALOG_KUSPIT_FINANCIAL_INSTITUTION_STATE_MANAGER)
  private readonly state_manager!: StateManager;

  @Inject(TYPES.CATALOG_KUSPIT_FINANCIAL_INSTITUTION_REPOSITORY)
  private readonly repository!: FinancialInstitutionRepository;

  internalExecute(): Promise<Array<FinancialInstitutionEntity>> {
    return new Promise((resolve, reject) => {
      if (!this.state_manager.state.loaded) {
        this.repository.findAll()
          .then((items) => {
            this.state_manager.patch({ items, loaded: true });
            resolve(items);
          })
          .catch(reject);
      } else {
        resolve(this.state_manager.state.items);
      }
    });
  }
}
